import { memo, useState } from "react";
import { useQuery } from "react-query";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import { HotelService } from "../../services/HotelService";
import { mdlRoomAndTypeListRequest } from "../../models/service-models/hotel/RoomAndTypeListRequest";
import { mdlIdCodeNamePair } from "../../models/domain/IdCodeNamePair";

export type RoomAndTypeSelectProps = {
    roomTypeList?:mdlIdCodeNamePair[] ;
    roomList?:mdlIdCodeNamePair[] ;
    onChange?: Function;
    selectedHotel?:string;
    defaultValue?: string | string[];
    excludedValue?:string;
    mode?: 'multiple' | 'tags' | undefined;
}


export const RoomAndTypeSelect = memo(function RoomAndTypeSelect(props: RoomAndTypeSelectProps) {
    const { t } = useTranslation();
    const [RoomAndTypeListRequest, setRoomAndTypeListRequest] = useState<mdlRoomAndTypeListRequest>({ pageSize: 0 });
    return (
        <>
            <Select
                style={{width:"100%"}}
                size="middle"
                mode={props.mode}
                defaultValue={props.defaultValue}
                onSelect={(value: string) => props.onChange ? props.onChange(value) : undefined}
                showSearch
                placeholder={t("common.chooseRoomAndType")}
                filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                options={props.roomTypeList?.map(h => Object.assign((h), {
                    label: h.name,
                    value: h.id
                })).filter((x) => !props.excludedValue || (props.excludedValue && x.value != props.excludedValue))}
            />
        </>
    )
})